import { CURRENCIES, Money, type Currency, type TyreDetail, type TyreInput } from '@chukua/common';

export { CURRENCIES };

export interface TyreFormValues {
  serial: string;
  /** Catalogue ids; the pickers set them, and the form requires both. */
  brandId?: string;
  sizeId?: string;
  pattern: string;
  /** Major units as typed (KES 45,000.00); converted to minor units on save. */
  cost: number | null;
  currency: Currency;
  supplierId?: string;
  purchasedOn: string;
}

export function blankTyreForm(): TyreFormValues {
  return { serial: '', pattern: '', cost: null, currency: 'KES', purchasedOn: new Date().toISOString().slice(0, 10) };
}

export function tyreToFormValues(tyre: TyreDetail): TyreFormValues {
  return {
    serial: tyre.serial,
    brandId: tyre.brandId ?? undefined,
    sizeId: tyre.sizeId ?? undefined,
    pattern: tyre.pattern,
    cost: Number(Money.ofMinor(tyre.cost.amountMinor, tyre.cost.currency).toDecimalString()),
    currency: tyre.cost.currency,
    supplierId: tyre.supplierId ?? undefined,
    purchasedOn: tyre.purchasedOn,
  };
}

/** Never floats in money: the typed figure is parsed as a decimal string into whole minor units. */
export function toTyreInput(values: TyreFormValues): TyreInput {
  return {
    serial: values.serial.trim(),
    brandId: values.brandId ?? '',
    sizeId: values.sizeId ?? '',
    pattern: values.pattern.trim(),
    cost: Money.parse((values.cost ?? 0).toFixed(Money.decimalPlaces(values.currency)), values.currency).toJSON(),
    supplierId: values.supplierId ?? null,
    purchasedOn: values.purchasedOn,
  };
}
